// Diálogo autogenerado del modo "Video con influencer" (ADR-674).
//
// Al entrar a la pantalla de configurar CON un producto elegido, el front pide
// el guion y lo deja escrito en el textarea (editable). Reemplaza al viejo modo
// "Automático", donde el guion lo inventaba el backend al generar el video y el
// usuario nunca lo veía.
//
// Backend: POST /v1/videos/influencer/dialogo (migración de
// `webhook/generar_dialogo` de n8n). SÍNCRONO — responde `{ response: string }`.
// Es GRATIS: no consume créditos.

import { atlasBackendFetch } from '../../lib/atlasBackend';

/** Tope del lado del front. El backend corta a los 30s; acá dejamos un poco más
 *  para que el error que gane sea el suyo (tipado) y no un abort mudo. */
const DIALOGO_TIMEOUT_MS = 35_000;

/**
 * Pide el diálogo sugerido para una variante. Devuelve el texto listo para
 * poner en el textarea.
 *
 * Tira si el backend falla — el caller muestra el aviso y deja escribir a mano
 * (la autogeneración es una comodidad, nunca un bloqueo).
 */
export async function fetchInfluencerDialogo(
  varianteId: string,
): Promise<string> {
  const res = await atlasBackendFetch(
    '/v1/videos/influencer/dialogo',
    { variante_id: varianteId },
    { signal: AbortSignal.timeout(DIALOGO_TIMEOUT_MS) },
  );
  const text = await res.text().catch(() => '');
  if (!res.ok) {
    let msg: string | null = null;
    try {
      const j = text ? JSON.parse(text) : null;
      msg = j?.message ?? j?.error ?? null;
    } catch {
      /* body no-JSON → cae al texto crudo */
    }
    throw new Error(msg || `Error ${res.status}`);
  }
  try {
    const j = text ? JSON.parse(text) : null;
    // Misma clave que el webhook viejo (`{ response }`), a propósito.
    return typeof j?.response === 'string' ? j.response.trim() : '';
  } catch {
    return '';
  }
}
